import { hotspots } from '../data/hotspots';
import { groups } from '../data/groups';

export default function Navigation({
  view,
  activeId,
  activeGroupId,
  onWarehouseClick,
  onHotspotSelect,
  onGroupSelect,
  onBackToHome,
  onBackToHotspots,
  onBackToGroups,
}) {
  const activeHotspot = hotspots.find((h) => h.id === activeId) || null;
  const activeGroup = activeGroupId ? groups[activeGroupId] : null;
  const zoneGroups = activeHotspot
    ? activeHotspot.groups.map((id) => groups[id]).filter(Boolean)
    : [];

  // ── Level 0: Warehouse entry ──────────────────────────────
  if (view === 'home') {
    return (
      <div className="nav-wrapper">
        <nav className="nav-list">
          <button className="nav-item" onClick={onWarehouseClick}>
            <span className="nav-item__dot" />
            <span className="nav-item__label">Warehouse</span>
          </button>
          <div className="nav-item nav-item--future">
            <span className="nav-item__dot" />
            <span className="nav-item__label">Manufacturing</span>
            <span className="nav-item__badge">Coming Soon</span>
          </div>
          <div className="nav-item nav-item--future">
            <span className="nav-item__dot" />
            <span className="nav-item__label">Cold Storage</span>
            <span className="nav-item__badge">Future</span>
          </div>
          <div className="nav-item nav-item--future">
            <span className="nav-item__dot" />
            <span className="nav-item__label">Parcel / Post</span>
            <span className="nav-item__badge">Future</span>
          </div>
        </nav>
        <div className="sidebar__description sidebar__description--muted">
          <p>MHI is a global industry association that connects companies and professionals involved in material handling, warehousing, and supply chain technologies, while promoting innovation, education, and collaboration in the logistics sector.</p>
        </div>
      </div>
    );
  }

  // ── Level 1: Zone / hotspot list ─────────────────────────
  if (view === 'hotspots') {
    return (
      <div className="nav-wrapper">
        <nav className="nav-list">
          <button className="nav-back-btn" onClick={onBackToHome}>
            ← Back to Warehouse
          </button>
          {hotspots.map((spot) => (
            <button
              key={spot.id}
              className={`nav-item${activeId === spot.id ? ' nav-item--active' : ''}`}
              onClick={() => onHotspotSelect(spot.id)}
            >
              <span className="nav-item__dot" />
              <span className="nav-item__label">{spot.label}</span>
            </button>
          ))}
        </nav>
        {!activeHotspot && (
          <div className="sidebar__description sidebar__description--muted">
            <p>Select a zone to explore the relevant industry groups.</p>
          </div>
        )}
      </div>
    );
  }

  // ── Level 2: Group list for a zone ───────────────────────
  if (view === 'groups') {
    return (
      <div className="nav-wrapper">
        <div className="nav-list nav-list--compact">
          <button className="nav-back-btn" onClick={onBackToHotspots}>
            ← Back to Zones
          </button>
          {activeHotspot && (
            <div className="nav-zone-label">{activeHotspot.label}</div>
          )}
        </div>
        <div className="groups-list">
          {zoneGroups.map((group) => (
            <button
              key={group.id}
              className="group-item"
              onClick={() => onGroupSelect(group.id)}
            >
              <div className="group-item__header">
                <span className="group-item__name">{group.name}</span>
                <span className="group-item__arrow">›</span>
              </div>
              <p className="group-item__snippet">{group.shortDescription}</p>
            </button>
          ))}
        </div>
      </div>
    );
  }

  // ── Level 3: Full group description ──────────────────────
  if (view === 'group-detail') {
    return (
      <div className="nav-wrapper">
        <div className="nav-list nav-list--compact">
          <button className="nav-back-btn" onClick={onBackToGroups}>
            ← Back to {activeHotspot?.label || 'Groups'}
          </button>
        </div>
        <div className="group-detail">
          {activeGroup?.logo && (
            <div className={`group-detail__logo-wrap${activeGroup.logoWhiteBg ? ' group-detail__logo-wrap--white' : ''}`}>
              <img
                src={activeGroup.logo}
                alt={activeGroup.name}
                className="group-detail__logo"
                onError={(e) => { e.currentTarget.style.display = 'none'; }}
              />
            </div>
          )}
          <h3 className="group-detail__name">{activeGroup?.name}</h3>
          {activeGroup?.fullDescription.split('\n\n').map((para, i) => (
            <p key={i} className="group-detail__para">{para}</p>
          ))}
          {activeGroup?.resources?.length > 0 && (
            <div className="group-detail__resources">
              <h4 className="group-detail__resources-title">Valuable Resources</h4>
              <ul className="group-detail__resources-list">
                {activeGroup.resources.map((r, i) =>
                  r.url ? (
                    <li key={i}>
                      <a href={r.url} className="group-detail__link" target="_blank" rel="noreferrer">
                        {r.label}
                      </a>
                    </li>
                  ) : (
                    <li key={i}>
                      <span className="group-detail__link group-detail__link--muted">{r.label}</span>
                    </li>
                  )
                )}
              </ul>
            </div>
          )}
        </div>
      </div>
    );
  }

  return null;
}
